<template>
    <v-dialog v-if="data.length > 0" v-model="dialog" width="600px">
        <template #activator="{ on }">
            <slot name="button" :dialog="dialog" :on="on"> </slot>
        </template>
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                <v-icon class="mr-1" color="default">fa-question-circle</v-icon>
                {{ title }}
                <v-spacer></v-spacer>
                <v-icon @click="triggerFalse">fa-times</v-icon>
            </v-card-title>
            <v-card-text>
                <div v-for="(page, index) in data" :key="index" class="mt-5">
                    <h6 v-html="page.title">{{ page.title }}</h6>
                    <p v-html="page.content">{{ page.content }}</p>
                    <v-divider v-if="index !== last"></v-divider>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-3" color="grey darken-1" dark title="Close" @click="triggerFalse">
                    <i class="fa fa-times mr-1"></i> Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'HelpDialog',
    props: {
        route: {
            type: String,
            required: false,
            default: 'test.route',
        },
        title: {
            type: String,
            required: false,
            default: 'help-pages::dialog.title',
        },
        falseBtnIcon: {
            type: String,
            required: false,
            default: '<i class="fa fa-times"></i>',
        },
        falseBtnText: {
            type: String,
            required: false,
            default: 'help-pages::dialog.button.close',
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            data: [],
        };
    },
    computed: {
        last() {
            return Object.keys(this.data).length - 1;
        },
    },
    created() {
        this.loadHelpPages();
    },
    methods: {
        triggerTrue() {
            this.dialog = false;
            this.$emit('true');
        },
        triggerFalse() {
            this.dialog = false;
            this.$emit('false');
        },
        loadHelpPages() {
            if (!this.can('api.v1.help-pages.data')) {
                return;
            }
            this.loading = true;

            axios.get(route('api.v1.help-pages.data', this.route)).then((response) => {
                this.data = response.data && response.data.length ? response.data : this.data;
                this.loading = false;
            });
        },
    },
};
</script>

<style scoped>
button,
[role='button'] {
    outline: none !important;
}
</style>
